export default {
    appId: 'nonrev-home-page',
    lang: 'en',
    site: 'nonrev'
};
